import React, { useEffect, useRef } from 'react';
import Parallax from 'parallax-js'; // Now published on NPM

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    overflow: 'hidden !important',
    display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center'
    height: '50rem',
    [theme.breakpoints.down('lg')]: {
      height: '40rem'
    },
    [theme.breakpoints.down('md')]: {
      height: '35rem'
    },
    [theme.breakpoints.down('xs')]: {
      height: '30rem'
    },
  },
  sectionDesktop: {
    display: 'none',
  },
  logo: {
    transform: 'scale(1)',
    [theme.breakpoints.down('md')]: {
      transform: 'scale(0.8)',
    },
    [theme.breakpoints.down('sm')]: {
      transform: 'scale(0.8)',
    },
    [theme.breakpoints.down('xs')]: {
      transform: 'scale(0.6)',
    },
  },
  img: {
    transform: 'scale(1.2)',
    [theme.breakpoints.down('md')]: {
      height: '45rem'
    },
    [theme.breakpoints.down('sm')]: {
      height: '35rem'
    },
    [theme.breakpoints.down('xs')]: {
      height: '35rem',
      transform: 'translateX(-19rem)'
    },
  },
  header: {
    
  },
  logoBox: {
    position: 'absolute',
    height: '50rem',

    width: '1920px',
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      height: '40rem'
    },
    [theme.breakpoints.down('md')]: {
      height: '35rem'
    },
    [theme.breakpoints.down('xs')]: {
      height: '30rem'
    },
  }
}));

export default function App() {
  const classes = useStyles();
  const scene = useRef(null);
  // const styles = {
  // }
  useEffect(() => {
    const parallaxInstance = new Parallax(scene.current, {
      relativeInput: true,
      hoverOnly: true,
    })
    parallaxInstance.enable();

    return () => parallaxInstance.disable();
  }, [])

  return (
    <>
      <div
        className={classes.container}
        ref={scene}
      >
        <li
          className="layer cloud"
          data-depth="0.15"
          id="parallax-img"
        >
          <img
            alt=""
            className={classes.img}
            src="./img/header/header_plan_5.webp"
          />
        </li>
        <li
          className="layer"
          data-depth=".25"
          id="parallax-img"
        >
          <img
            alt=""
            className={classes.img}
            src="./img/header/header_plan_4.webp"
          />
        </li>
        <li
          className="layer"
          data-depth=".35"
          id="parallax-img"
        >
          <img
            alt=""
            className={classes.img}
            src="./img/header/header_plan_3.webp"
          />
        </li>
        <li
          className="layer"
          data-depth=".45"
          id="parallax-img"
        >
          <img
            alt=""
            className={classes.img}
            src="./img/header/header_plan_2.webp"
          />
        </li>
        <li
          className="layer"
          data-depth=".75"
          id="parallax-img"
        >
          <img
            alt=""
            className={classes.img}
            src="./img/header/header_plan_1.webp"
          />
        </li>
      </div>
      <Grid
        className={classes.logoBox}
      >
        <img
          alt=""
          className={classes.logo}
          component="img"
          src="./img/header/logo.webp"
        />
      </Grid>
    </>
  )
}


// import React, { useEffect, useRef } from 'react';
// import Parallax from 'parallax-js'; // Now published on NPM
// import CardMedia from '@material-ui/core/CardMedia'

// export default function App() {
//   const scene = useRef(null);
//   const styles = {
//     container: { overflow: 'hidden', height: '60vh', maxHeight: '100vh !important', alignItems: 'center', justifyContent: 'center' },
//     img: { minWidth: '100vw', maxWidth: '100vw', transform: 'scale(1.4)', top: 0, left: 0 },
//   }
//   useEffect(() => {
//     const parallaxInstance = new Parallax(scene.current, {
//       relativeInput: true,
//       hoverOnly: true,
//     })
//     parallaxInstance.enable();

//     return () => parallaxInstance.disable();
//   }, [])

// return (
//   <div
//     className="header-container"
//     ref={scene}
//     style={styles.container}
//   >
//     <li
//       className="layer"
//       data-depth="0"
//       id="parallax-img"
//     >
//       <img
//         alt=""
//         src="./img/header/header_plan_6.png"
//         style={styles.img}
//       />
//     </li>
//     <li
//       className="layer cloud_bis"
//       data-depth="0.1"
//       id="parallax-img"
//     >
//       <img
//         alt=""
//         src="./img/header/header_plan_7.png"
//         style={styles.img}
//       />
//     </li>
//     <li
//       className="layer cloud"
//       data-depth="0.15"
//       id="parallax-img"
//     >
//       <img
//         alt=""
//         src="./img/header/header_plan_5.png"
//         style={styles.img}
//       />
//     </li>
//     <li
//       className="layer"
//       data-depth=".25"
//       id="parallax-img"
//     >
//       <img
//         alt=""
//         src="./img/header/header_plan_4.png"
//         style={styles.img}
//       />
//     </li>
//     <li
//       className="layer"
//       data-depth=".35"
//       id="parallax-img"
//     >
//       <img
//         alt=""
//         src="./img/header/header_plan_3.png"
//         style={styles.img}
//       />
//     </li>
//     <li
//       className="layer"
//       data-depth=".45"
//       id="parallax-img"
//     >
//       <img
//         alt=""
//         src="./img/header/header_plan_2.png"
//         style={styles.img}
//       />
//     </li>
//     <li
//       className="layer"
//       data-depth=".75"
//       id="parallax-img"
//     >
//       <img
//         alt=""
//         src="./img/header/header_plan_1.png"
//         style={styles.img}
//       />
//     </li>
//     <li
//       className="layer logo"
//       data-depth=""
//     >
//       <CardMedia
//         alt=""
//         component="img"
//         src="./img/header/header_plan_0.png"
//         style={styles.img}
//       />
//     </li>
//   </div>
//   )
// }
